import { getPublicRouteUrl } from '@nackle/service-urls';

export const API_ENDPOINT = getPublicRouteUrl( 'CELEBRATION_SERVICE' );
